export default {
  "Cut Audio": "Audio Knippen",
  "HitPaw Online Audio Cutter": "HitPaw Online Audio Knipper",
  "Trim or cut any audio files online.": "Audiobestanden online bijsnijden of knippen.",
  "Cut": "Knippen",
  "Fade in": "Fade in",
  "Fade out": "Fade uit",
  "Cut from": "Knippen van",
  "to": "naar",
  "Extract selection": "Selectie extraheren",
  "Delete selection": "Selectie verwijderen",
  "Adjust New": "Aanpassen Nieuw",
  "Cut New": "Nieuw knippen",
  "Adjust Volume": "Volume aanpassen",
  "HitPaw Online Volume Changer": "HitPaw Online volumewisselaar",
  "Turn up or Turn down the volume of audio.": "Zet het volume van audio harder of zachter.",
  "Volume": "Volume",
  "Change Speed": "Snelheid veranderen",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Audio Snelheidswisselaar",
  "Speed up or slow down audios online easily.": "Versnel of vertraag gemakkelijk audio online.",
  "Speed": "Snelheid",
  "Format": "Formaat",
  "Size": "Grootte",
  "Duration": "Duur",
};
